import React from "react";
import { useHistory } from "react-router-dom";

const useDashboardSwitcher = () => {
  const history = useHistory();

  const setLocation = (location) => {
    history.push(location);
  };

  return {
    history,
    setLocation,
  };
};

const DashboardSwitcher = () => {
  const { setLocation, history } = useDashboardSwitcher();

  return (
    <div className="level-item">
      <div className="select is-medium">
        <select
          onChange={(event) => setLocation(event.target.value)}
          value={history.location.pathname}
        >
          <option value="/dashboard">Eficiencia de Entrega</option>
          <option value="/dashboard/average_eta">Días promedio</option>
          <option value="/dashboard/part_status">Status de partes</option>
          <option value="/dashboard/catering">Abastecimiento</option>
        </select>
      </div>
    </div>
  );
};

export default DashboardSwitcher;
